import { gql } from "apollo-boost";

export const TEST_UNDERWRITE = gql`
  mutation testUserUnderwrite(
    $userEmail: String!
    $ignoreOverdraft: Boolean
    $ignoreBankAge: Boolean
  ) {
    testUnderwrite(
      userEmail: $userEmail
      ignoreOverdraft: $ignoreOverdraft
      ignoreBankAge: $ignoreBankAge
    ) {
      status
      code
      message
      application_status
      credit_limit
    }
  }
`;

export const REJECT_USER_APPLICATION = gql`
  mutation RejectUserApplication($userId: String!, $reason: String) {
    rejectUser(userId: $userId, reason: $reason) {
      status
      code
      message
    }
  }
`;

export const FETCH_BALANCES = gql`
  query FetchBalances($userId: ID, $accounts: [String]) {
    balances(userId: $userId, accounts: $accounts) {
      name
      account_id
      type
      subtype
      balances {
        available_balance
        current_balance
        created_at
      }
    }
  }
`;

export const RESOLVE_LIMIT_REQUEST = gql`
  mutation ResolveLimitRequest($userId: ID) {
    resolveLimitRequest(userId: $userId) {
      status
      code
      message
    }
  }
`;

export const RESET_USER_APPLICATION = gql`
  mutation ResetUserApplication(
    $userId: String!
    $step: Int
    $all: Boolean
    $resendInvite: Boolean
  ) {
    resetApplication(
      userId: $userId
      step: $step
      all: $all
      resendInvite: $resendInvite
    ) {
      status
      code
      message
    }
  }
`;

export const UPDATE_USER_APPLICATION = gql`
  mutation UpdateUser($application: UserApplicationInput!, $email: String!) {
    updateUser(application: $application, email: $email) {
      email
      application {
        dashboard_terms_accepted
        terms_accepted
        pp_accepted
        has_resumed
        basic_info
        verify_phone
        address
        personal_information
        verify_id
        link_bank
        student
        confirm
        last_completed_step
      }
    }
  }
`;

export const UPDATE_NOTIFICATION = gql`
  mutation UpdateNotification($id: ID!, $payload: NotificationUpdateInput) {
    updateNotification(id: $id, payload: $payload) {
      status
      code
      message
    }
  }
`;

export const RESOLVE_EVENT = gql`
  mutation ResolveEvent($id: ID!, $aggregator: String) {
    resolveEvent(id: $id, aggregator: $aggregator) {
      status
      code
      message
    }
  }
`;

export const ACTIVATE_CARD = gql`
  mutation ActivateCard($lastFour: String!, $month: String!, $year: String!) {
    activateCard(lastFour: $lastFour, month: $month, year: $year) {
      status
      code
      message
    }
  }
`;

export const SET_CREDIT_LIMIT = gql`
  mutation SetCreditLimit($user_id: ID!, $new_limit: Int!, $reason: String!) {
    setCreditLimit(user_id: $user_id, new_limit: $new_limit, reason: $reason) {
      status
      code
      message
    }
  }
`;

export const FREEZE_USER_CARD = gql`
  mutation FreezeUserCard(
    $user_id: ID
    $reason: String
    $notifyEmail: Boolean
    $notifyText: Boolean
    $notes: FreezeCardNotes
  ) {
    freezeUserCard(
      user_id: $user_id
      reason: $reason
      notifyEmail: $notifyEmail
      notifyText: $notifyText
      notes: $notes
    ) {
      status
      code
      message
    }
  }
`;

export const FREEZE_USER_CARD_BY_USER = gql`
  mutation FreezeUserCardByUser($user_id: ID) {
    freezeUserCardByUser(user_id: $user_id) {
      status
      code
      message
    }
  }
`;

export const UNFREEZE_USER_CARD = gql`
  mutation UnfreezeUserCard(
    $user_id: ID
    $reason: String
    $notifyEmail: Boolean
    $notifyText: Boolean
  ) {
    unfreezeUserCard(
      user_id: $user_id
      reason: $reason
      notifyEmail: $notifyEmail
      notifyText: $notifyText
    ) {
      status
      code
      message
    }
  }
`;

export const UNFREEZE_USER_CARD_BY_USER = gql`
  mutation UnfreezeUserCardByUser($user_id: ID) {
    unfreezeUserCardByUser(user_id: $user_id) {
      status
      code
      message
    }
  }
`;

export const FREEZE_CARD = gql`
  mutation FreezeCard($user_id: ID!) {
    freezeCard(user_id: $user_id) {
      status
      code
      message
    }
  }
`;
export const UNFREEZE_CARD = gql`
  mutation UnfreezeCard($user_id: ID!) {
    unfreezeCard(user_id: $user_id) {
      status
      code
      message
    }
  }
`;

export const NOTIFICATIONS_QUERY = gql`
  query Notifications($priority: Int, $page: Int = 0, $perPage: Int = 20) {
    notifications(priority: $priority, page: $page, perPage: $perPage) {
      uuid
      created_at
      title
      subtitle
      body
      priority
      list {
        name
        value
      }
      link {
        text
        route
      }
      read
      resolved
      dismissed
      deleted
    }
  }
`;

export const PROCESS_PAYMENT = gql`
  mutation ProcessPayment(
    $payment_method: String!
    $amount: Float!
    $idempotencyKey: String!
  ) {
    processPayment(
      payment_method: $payment_method
      amount: $amount
      idempotencyKey: $idempotencyKey
    ) {
      status
      code
      message
    }
  }
`;

export const CANCEL_PAYMENT = gql`
  mutation CancelPayment($id: ID!, $user_id: ID) {
    cancelPayment(id: $id, user_id: $user_id) {
      status
      code
      message
    }
  }
`;

export const CANCEL_SCHEDULED_PAYMENT = gql`
  mutation CancelScheduledPayment($scheduledPaymentUuid: String!, $customersEmail: String!) {
    cancelScheduledPayment(
      scheduledPaymentUuid: $scheduledPaymentUuid, 
      customersEmail: $customersEmail
      ) {
      status
      code
      message
    }
  }
`;

export const PAYMENT_METHODS_QUERY = gql`
  query Dashboard {
    user {
      api_type
      aggregator_type
      payment_methods {
        id
        aggregator
        nickname
        institution
        institution_id
        logo
        logoURL
        type
        account_number_last_four
        unlinked
        relink_id
        needs_account_routing_numbers
        manually_updated_on
      }
      card {
        activated
      }
    }
  }
`;

export const UPDATE_PAYMENT_METHODS = gql`
  mutation UpdatePaymentMethods(
    $autopay_frequency: String
    $smart_pay: Boolean
    $default_payment_method_id: String
    $secondary_payment_method_id: String
  ) {
    updateUser(
      default_payment_method_id: $default_payment_method_id
      secondary_payment_method_id: $secondary_payment_method_id
      autopay_frequency: $autopay_frequency
      smart_pay: $smart_pay
    ) {
      default_payment_method_id
      secondary_payment_method_id
      autopay_frequency
      smart_pay
    }
  }
`;

export const REFETCH_PAYMENT_METHODS = gql`
  query RefetchPaymentMethods {
    user {
      payment_methods {
        id
        nickname
        institution
        logo
        logoURL
        type
        account_number_last_four
        unlinked
        relink_id
      }
      default_payment_method_id
      secondary_payment_method_id
      autopay_frequency
      smart_pay
    }
  }
`;

export const ADD_PAYMENT_METHOD = gql`
  mutation AddPaymentMethod(
    $accounts: [PlaidAddedAccount]
    $institution: PlaidAddedInstitution
    $link_session_id: String
    $public_token: String
  ) {
    addPaymentMethod(
      accounts: $accounts
      institution: $institution
      link_session_id: $link_session_id
      public_token: $public_token
    ) {
      status
      code
      error
      message
      accounts {
        id
        nickname
        account_number_last_four
      }
    }
  }
`;

export const REMOVE_PAYMENT_METHOD = gql`
  mutation RemovePaymentMethod($id: ID, $userId: String) {
    removePaymentMethod(id: $id, userId: $userId) {
      status
      code
      error
      message
    }
  }
`;

export const REFETCH_CARD_STATUS = gql`
  query RefetchCardStatus {
    user {
      card {
        status
      }
    }
  }
`;

export const DASHBOARD_QUERY = gql`
  query Dashboard {
    user {
      api_type
      aggregator_type
      type
      rewards {
        available_points
      }
      credit {
        credit_limit
        credit_used
        credit_available
      }
      autopay_frequency
      next_trigger_date
      default_payment_method_id
      payment_methods {
        id
        nickname
        institution
        institution_id
        type
        logo
        logoURL
        account_number_last_four
        aggregator
        needs_account_routing_numbers
        manually_updated_on
      }
      payment_due_date
      payment_due_balance
      delinquent
      alternative_payment_link
      application {
        dashboard_terms_accepted
      }
      cashback_percentage
      referral_code
      card {
        activated
        metadata
        status
      }
      is_email_verified
      pending_activity_summary {
        count
        volume
      }
      showOffers
      offers {
        name
        subtext
        value {
          text
          style
        }
        imageUrl
        externalUrl
      }
    }
  }
`;

export const HEADER_QUERY = gql`
  query Header {
    simpleUser {
      first_name
      last_name
      referral_code
      type
    }
  }
`;

export const BOOST_LANDING_CC_QUERY = gql`
  query BoostLandingCc {
    simpleUser {
      first_name
      last_name
      credit {
        credit_limit
      }
    }
  }
`;

export const LOCKED_STATUS_QUERY = gql`
  query userLockedStatus {
    userLockedStatus {
      lock_type
      lock_details {
        message
        severity
        icon
      }
      payment_required
      total_transactions_settled_amount
      total_payments_settled_amount
      payment_due
      missed_payment
      missed_payment_info {
        created_at
        updated_at
        settled_at
        amount
        status
        category
        is_paid_by_user
      }
      pending_payments_info {
        created_at
        updated_at
        settled_at
        amount
        status
        category
        is_paid_by_user
      }
      payment_methods {
        id
        nickname
        institution
        logo
        type
        account_number_last_four
        logo
        logoURL
      }
      default_payment_method_id
      card {
        status
      }
    }
  }
`;

export const REQUEST_CREDIT_LIMIT_INCREASE = gql`
  mutation RequestCreditLimitIncrease(
    $name: String
    $phone: String
    $reason: String
    $income: String
    $employed: String
    $employmentDetail: String
    $rent: String
    $desiredLimit: String
    $social: String
    $additionalAccountsAdded: Boolean
  ) {
    requestCreditLimitIncrease(
      name: $name
      phone: $phone
      reason: $reason
      income: $income
      employed: $employed
      employmentDetail: $employmentDetail
      rent: $rent
      desiredLimit: $desiredLimit
      social: $social
      additionalAccountsAdded: $additionalAccountsAdded
    ) {
      status
      code
      message
    }
  }
`;

export const FINICITY_CONNECT_LINK_QUERY = gql`
  query FinicityConnectLink($aggregation: Boolean) {
    finicityConnect(aggregation: $aggregation) {
      link
    }
  }
`;

export const UPDATED_FINICITY_PAYMENT_METHODS = gql`
  mutation UpdateFinicityPaymentMethods {
    updateFinicityPaymentMethods {
      status
      code
      message
    }
  }
`;

export const CREATE_NOTE = gql`
  mutation CreateNote(
    $user_id: ID!
    $body: String
    $text: String
    $tags: String
  ) {
    createNote(user_id: $user_id, body: $body, text: $text, tags: $tags) {
      status
      code
      message
      payload
    }
  }
`;

export const UPDATE_NOTE = gql`
  mutation UpdateNote($id: ID!, $body: String, $text: String, $tags: String) {
    updateNote(id: $id, body: $body, text: $text, tags: $tags) {
      status
      code
      message
    }
  }
`;

export const REMOVE_NOTE = gql`
  mutation RemoveNote($id: ID) {
    removeNote(id: $id) {
      status
      message
    }
  }
`;

export const LOST_CARD_RESEND = gql`
  mutation LostCardResend($user_id: ID!) {
    lostCardResend(user_id: $user_id) {
      status
      code
      message
    }
  }
`;

export const REISSUE_CARD = gql`
  mutation ReissueCard($user_id: ID!) {
    reissueCard(user_id: $user_id) {
      status
      code
      message
    }
  }
`;

export const SET_USER_TAGS = gql`
  mutation UpdateTag($user_id: ID!, $tags: String) {
    updateUserData(user_id: $user_id, tags: $tags) {
      status
      code
      message
    }
  }
`;

export const RESOLVE_FRAUD_TAG = gql`
  mutation ResolveFraudTag($user_id: ID!, $action: String) {
    resolveFraudTag(user_id: $user_id, action: $action) {
      status
      code
      message
    }
  }
`;

export const UPDATE_USER_DISPUTE = gql`
  mutation UpdateUserDispute(
    $dispute_id: ID!
    $reason_code: Int
    $disputed_amount: Float
    $questionnaire: String
  ) {
    updateUserDispute(
      dispute_id: $dispute_id
      reason_code: $reason_code
      disputed_amount: $disputed_amount
      questionnaire: $questionnaire
    ) {
      status
      code
      message
    }
  }
`;

export const RESOLVE_USER_DISPUTE = gql`
  mutation resolveUserDispute($dispute_id: ID!, $action: String) {
    resolveDispute(dispute_id: $dispute_id, action: $action) {
      status
      code
      message
    }
  }
`;

export const SEND_EMAILS = gql`
  mutation sendEmails(
    $templateId: String!
    $data: String!
    $batchName: String!
    $sender: String
  ) {
    sendEmails(templateId: $templateId, data: $data, batchName: $batchName, sender: $sender) {
      status
      code
      message
      payload
    }
  }
`;

export const SEND_TEST_EMAIL = gql`
  mutation sendTestEmail($templateId: String!, $data: String!, $sender: String) {
    sendTestEmail(templateId: $templateId, data: $data, sender: $sender) {
      status
      code
      message
    }
  }
`;

export const RUN_TWN = gql`
  mutation RunTWN($userId: String, $forceNewTWN: Boolean) {
    runTWN(userId: $userId, forceNewTWN: $forceNewTWN) {
      status
      code
      message
      payload
    }
  }
`;

export const SUBMIT_DISPUTE = gql`
  mutation DisputeTransaction(
    $user_id: ID
    $transaction_id: ID!
    $disputed_amount: String!
    $form: String!
  ) {
    disputeTransaction(
      user_id: $user_id
      transaction_id: $transaction_id
      disputed_amount: $disputed_amount
      form: $form
    ) {
      status
      code
      message
    }
  }
`;

export const REMOVE_USER_TRANSACTION_TAG = gql`
  mutation RemoveUserTransactionTag($transaction_id: ID!, $tag: String!) {
    removeUserTransactionTag(transaction_id: $transaction_id, tag: $tag) {
      transaction_id
      tags
    }
  }
`;

export const ADD_USER_TRANSACTION_TAGS = gql`
  mutation AddUserTransactionTags($transaction_id: ID!, $tags: [String]!) {
    addUserTransactionTags(transaction_id: $transaction_id, tags: $tags) {
      transaction_id
      tags
    }
  }
`;

export const SEND_TEST_SMS = gql`
  mutation SendTestSms($body: String!, $phone_number: String!) {
    sendTestSMS(body: $body, phone_number: $phone_number) {
      status
      code
      message
    }
  }
`;

export const SEND_SMS = gql`
  mutation SendSMS($body: String!, $data: String!, $batchName: String!) {
    sendSMS(body: $body, data: $data, batchName: $batchName) {
      status
      code
      message
    }
  }
`;

export const SEND_TEST_PUSH = gql`
  mutation SendTestPushNotification(
    $body: String!
    $title: String!
    $email: String!
  ) {
    sendTestPushNotification(body: $body, title: $title, email: $email) {
      status
      code
      message
    }
  }
`;

export const SEND_PUSH = gql`
  mutation SendPushNotifications(
    $body: String!
    $title: String!
    $data: String!
    $batchName: String!
  ) {
    sendPushNotifications(
      body: $body
      title: $title
      data: $data
      batchName: $batchName
    ) {
      status
      code
      message
    }
  }
`;

export const GET_BATCHES = gql`
  query getBatches($type: String!) {
    getBatches(type: $type)
  }
`;

export const GET_BATCH_DOWNLOAD = gql`
  query downloadBatchReport($batchName: String!, $type: String!) {
    batchDownload(batchName: $batchName, type: $type) {
      batchName
      csv
    }
  }
`;

export const GET_ANALYTICS_DOWNLOAD = gql`
  query downloadAnalytics($batchName: String!, $type: String!) {
    analyticsDownload(batchName: $batchName, type: $type) {
      batchName
      delivered
      undelivered
      failed
      open
      click
    }
  }
`;

export const QUERY_ALL_TEMPLATES = gql`
  query AllTemplates {
    templates {
      id
      name
      updated_at
      versions {
        id
        name
        active
      }
    }
  }
`;

export const QUERY_TEMPLATE = gql`
  query TemplateVersion($templateId: String, $versionId: String) {
    template(templateId: $templateId, versionId: $versionId) {
      id
      name
      subject
      template_id
      active
      updated_at
      html_content
    }
  }
`;

export const ACCOUNT_REVIEW = gql`
  query AccountReview {
    accountReview {
      status
      message
      data
      createdAt
      fileName
    }
  }
`;

export const UPDATE_PAYMENT_METHOD_INFO = gql`
  mutation UpdatePaymentMethodInfo(
    $id: ID!
    $accountNumber: String!
    $routingNumber: String!
  ) {
    updatePaymentMethodInfo(
      id: $id
      accountNumber: $accountNumber
      routingNumber: $routingNumber
    ) {
      status
      code
      message
      error
    }
  }
`;

export const UPDATE_PHONE_NUMBER = gql`
  mutation updatePhoneNumber($email: String!, $phone_number: String!) {
    updatePhoneNumber(email: $email, phone_number: $phone_number) {
      status
      code
      message
    }
  }
`;

export const UPDATE_AUTOPAY = gql`
  mutation updateAutopay($email: String!, $agent_email: String!) {
    updateAutopay(email: $email, agent_email: $agent_email) {
      status
      code
      message
    }
  }
`;

export const UPDATE_DOB = gql`
  mutation updateDOB($email: String!, $dob: String!) {
    updateDOB(email: $email, dob: $dob) {
      status
      code
      message
    }
  }
`;

export const ISSUE_CREDIT = gql`
  mutation issueCredit(
    $email: String!
    $amount: Float!
    $type: String!
    $description: String
    $isDebit: Boolean
  ) {
    issueCredit(
      email: $email
      amount: $amount
      type: $type
      description: $description
      isDebit: $isDebit
    ) {
      status
      message
    }
  }
`;

export const REFUND_USER = gql`
  mutation RefundUser($email: String!, $amount: Float!, $paymentMethodId: Int) {
    refundUser(
      email: $email
      amount: $amount
      paymentMethodId: $paymentMethodId
    ) {
      status
      code
      message
    }
  }
`;

export const PROCESS_MANUAL_PAYMENT = gql`
  mutation processManualPayment(
    $customersEmail: String!
    $paymentMethod: String!
    $idempotencyKey: String!
    $amount: Float!
    $note: String!
    $now: Boolean!
    $scheduledDate: String
  ) {
    processManualPayment(
      customersEmail: $customersEmail
      paymentMethod: $paymentMethod
      idempotencyKey: $idempotencyKey
      amount: $amount
      note: $note
      now: $now
      scheduledDate: $scheduledDate
    ) {
      status
      code
      display_message
      message
    }
  }
`;

export const ADD_ACCOUNT = gql`
  mutation manuallyAddAccount(
    $user_id: Int!
    $type: String
    $monitor_balance: Boolean
    $account_number: String!
    $routing_number: String!
    $name: String!
    $institution: String
    $galileo_type: String!
    $agent_email: String!
  ) {
    manuallyAddAccount(
      user_id: $user_id
      type: $type
      monitor_balance: $monitor_balance
      account_number: $account_number
      routing_number: $routing_number
      name: $name
      institution: $institution
      galileo_type: $galileo_type
      agent_email: $agent_email
    ) {
      status
      code
      display_message
      message
    }
  }
`;

export const REMOVE_RELINK_REQUIRED_FLAG = gql`
  mutation removeRelinkRequiredFlag($email: String!, $agent_email: String!) {
    removeRelinkRequiredFlag(email: $email, agent_email: $agent_email) {
      status
      code
      message
    }
  }
`;

// reauthorise
export const REMOVE_PAYMENT_EXCLUSION_FLAG = gql`
  mutation removePaymentExclusionFlag(
    $payment_method_id: Int!
    $email: String!
    $agent_email: String!
  ) {
    removePaymentExclusionFlag(
      payment_method_id: $payment_method_id
      email: $email
      agent_email: $agent_email
    ) {
      status
      code
      message
    }
  }
`;

export const REMOVE_BANK_ACCOUNT_FOR_APPROVED_USERS = gql`
  mutation removeBankAccountsForApprovedUsers(
    $email: String!
    $paymentMethodID: Int!
    $agent_email: String!
  ) {
    removeBankAccountsForApprovedUsers(
      email: $email
      paymentMethodID: $paymentMethodID
      agent_email: $agent_email
    ) {
      status
      code
      message
    }
  }
`;

export const REMOVE_BANK_ACCOUNT_FOR_REJECTED_USERS = gql`
  mutation removeBankAccountsForRejectedUsers(
    $email: String!
    $agent_email: String!
  ) {
    removeBankAccountsForRejectedUsers(
      email: $email
      agent_email: $agent_email
    ) {
      status
      code
      message
    }
  }
`;

export const UPDATE_DEFAULT_PAYMENT_METHOD = gql`
  mutation updateDpm($email: String!, $newDpm: Int!, $agent_email: String!) {
    updateDpm(email: $email, newDpm: $newDpm, agent_email: $agent_email) {
      status
      code
      message
    }
  }
`;

export const UPDATE_BANK_ACCOUNT_DETAILS = gql`
  mutation updateAccountDetailsOnR03R04(
    $payment_method_id: Int!
    $email: String!
    $account_number: String
    $routing_number: String
    $type: String
    $institution: String
    $nickname: String
    $agent_email: String!
  ) {
    updateAccountDetailsOnR03R04(
      payment_method_id: $payment_method_id
      email: $email
      account_number: $account_number
      routing_number: $routing_number
      type: $type
      institution: $institution
      nickname: $nickname
      agent_email: $agent_email
    ) {
      status
      code
      message
    }
  }
`;

export const UPDATE_AMBASSADOR_STATUS = gql`
  mutation updateAmbassadorStatus($email: String!, $type: String!) {
    updateAmbassadorStatus(email: $email, type: $type) {
      status
      code
      message
    }
  }
`;

export const UPDATE_EMAIL = gql`
  mutation updateEmail(
    $oldEmail: String!
    $newEmail: String!
    $agent_email: String!
  ) {
    updateEmail(
      oldEmail: $oldEmail
      newEmail: $newEmail
      agent_email: $agent_email
    ) {
      status
      message
    }
  }
`;

// TODO add pushContentData for deep links
export const CREATE_MARKETING_CAMPAIGN = gql`
  mutation createMarketingCampaign(
      $uuid: String!,
      $email_template_id: String,
      $email_template_variables: [String!],
      $text_content: String,
      $text_content_variables: [String!],
      $push_content: String,
      $push_content_header: String,
      $push_content_variables: [String!],
      $scheduled_time: String!,
      $batch_name: String!,
      $cron_schedule: String,
      $sender: String,
      $column_names: [String!]!,
      $push_content_data: String,
  ) {
    createMarketingCampaign(
      uuid: $uuid
      email_template_id: $email_template_id,
      email_template_variables: $email_template_variables,
      text_content: $text_content,
      text_content_variables: $text_content_variables,
      push_content: $push_content,
      push_content_header: $push_content_header,
      push_content_variables: $push_content_variables,
      push_content_data: $push_content_data,
      scheduled_time: $scheduled_time,
      batch_name: $batch_name,
      cron_schedule: $cron_schedule,
      column_names: $column_names
      sender: $sender,
    ) {
      status
      message
    }
  }
`;

export const UPDATE_MARKETING_CAMPAIGN = gql`
  mutation updateMarketingCampaign(
      $uuid: String!,
      $status: String!
  ) {
    updateMarketingCampaign(
      uuid: $uuid
      status: $status
    ) {
      status
      message
    }
  }
`;

export const ADD_REVIEW_TO_LATEST_SUBMISSION_EVENT = gql`
  mutation addReviewToLatestApplicationSubmissionEvent($user_id: Int!) {
    addReviewToLatestApplicationSubmissionEvent(user_id: $user_id) {
      status
      code
      message
      display_message
    }
  }
`;

export const LATEST_TOMO_CREDIT_REPORT = gql`
  query LatestTomoCreditReport {
    latestTomoCreditReport {
      reportingMonth
      submissionDate
      usersReported
      usersCurrent
      usersLate30Days
      usersLate60Days
      usersLate90Days
      usersLate120Days
      usersLate150Days
      usersLate180OrMoreDays
      usersChargedOff
    }
  }
`;

export const LATEST_TOMO_CREDIT_REPORT_DOWNLOAD = gql`
  query LatestTomoCreditReportDownload {
    latestTomoCreditReportDownload {
      csv
      reportingMonth
      submissionDate
    }
  }
`;

export const USER_TOMO_CREDIT_REPORT = gql`
  query UserTomoCreditReport($email: String!) {
    userTomoCreditReport(email: $email) {
      consumerAccountNumber
      creditLimit
      portfolioType
      accountType
      dateOpened
      highestCredit
      termsDuration
      termsFrequency
      accountStatus
      paymentHistoryProfile
      currentBalance
      dateAccountInformation
      surName
      firstName
      dateBirth
      ecoaCode
      firstLineAddress
      city
      state
      zipCode
      dateLastPayment
      amountPastDue
      originalChargeOffAmount
      actualPaymentAmount
      reportingMonth
      submissionDate
    }
  }
`;

export const ZENDESK_URL_QUERY = gql`
  query Zendesk {
    getZendesk {
      ssoUrl
    }
  }
`;

export const BOOST_PRODUCT_SETTINGS_GQL = gql`
query SettingsProducts {
  getUserProductStatus(productId: "credit_boost") {
    status
    productTier
    productTerm
    productFreeTrial
    pastDueAmount
  }
  getUserBoostPayments {
    amount
    dueDate
  }
}
`;

export const UPDATE_BOOST_PAYMENT_METHOD = gql`
mutation updateBoostPaymentMethod(
  $setupIntentId: String, 
  $paymentMethodId: String, 
  $setAsDefault: Boolean,
  $makePayment: Boolean,
  ) {
  updateBoostPaymentMethod(
    setupIntentId: $setupIntentId, 
    paymentMethodId: $paymentMethodId, 
    setAsDefault: $setAsDefault,
    makePayment: $makePayment,
  ) {
    status
    message
  }
}
`;